var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger",class:[{ active: _vm.isActive }, { default: !_vm.isBackgroundImage }],on:{"click":function($event){return _vm.$emit('menu-click', $event)}}},[_c('div',{staticClass:"row row-top"}),_c('div',{staticClass:"row row-center"}),_c('div',{staticClass:"row row-bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }